import { Recurso, UseCaseRecursoAsync } from "lib.common/dist/CleanArch";
import { ProductoDetalleDsKey } from "../entities/ProductoTiendaDsKey";
import { UpdateProductoDetalleParams } from "../../utils/params/ProductoDetalleParams";
import { GestionarProductoDetalleRepository } from "../repositories/GestionarProductoDetalleRepository";
import { ErrDevGenerico } from "lib.common/dist/errorHandler";

export class UpdateProductoDetalleUseCase<
    T_OUT extends ProductoDetalleDsKey
> extends UseCaseRecursoAsync<UpdateProductoDetalleParams, T_OUT> {
    private repository: GestionarProductoDetalleRepository<T_OUT>;
    constructor(repository: GestionarProductoDetalleRepository<T_OUT>) {
        super();
        this.repository = repository;
    }

    async call(
        input: UpdateProductoDetalleParams
    ): Promise<Recurso<T_OUT>> {
        try {
            return await this.repository.updateProductoDetalle(input);
        } catch (error) {
            const errorCapa = new ErrDevGenerico(error as Error);
            return Recurso.fromError<T_OUT>(errorCapa);
        }
    }
}